module.exports = __webpack_public_path__ + "img/company.986e483e.svg";